// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card--pGloq{margin-top:9px;padding:0px;border:0px;background:#fff;box-shadow:none;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/app-header/components/HeaderMenu/parts/Links/styles.module.scss"],"names":[],"mappings":"AAAA,aACE,cAAA,CACA,WAAA,CACA,UAAA,CACA,eAAA,CACA,eAAA,CACA,eAAA","sourcesContent":[".card {\n  margin-top: 9px;\n  padding: 0px;\n  border: 0px;\n  background: #ffffff;\n  box-shadow: none;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card--pGloq`
};
export default ___CSS_LOADER_EXPORT___;
